import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "alignItems"];
import { Grid } from '@material-ui/core';
import { Children, forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated in favor of `Stack`.
 */
export var GridStack = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      children,
      alignItems = 'stretch'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var items = Children.toArray(children);
  return /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    container: true,
    wrap: "nowrap",
    direction: "column",
    alignItems: alignItems,
    children: items.map((item, idx) => /*#__PURE__*/_jsx(Grid, {
      item: true,
      zeroMinWidth: true,
      xs: alignItems === 'stretch' ? 12 : undefined,
      children: item
    }, idx))
  }));
});
if (process.env.NODE_ENV !== "production") GridStack.displayName = "GridStack";